export const VALUE_REQUIRED = 'This field is required';
export const EMAIL_REQUIRED = 'Please enter a valid email address.';
export const EMAIL_VALIDATION = 'Please enter a valid email or clear field.';
export const EMAIL_DUPLICATE_VALIDATION = 'Email address already in use, please use another email address.';
export const EMAIL_LENGTH_VALIDATION = 'Max length: 40 characters.';
export const PHONE_VALIDATION = 'Please enter a valid phone number.';
